import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Users, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { joinListByToken } from '../lib/meApi';

export default function JoinListPage() {
  const { shareToken } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('loading'); // loading | success | error | unauth
  const [listId, setListId] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Save the join link and redirect to login
      sessionStorage.setItem('pending_join_token', shareToken);
      setState('unauth');
      return;
    }
    (async () => {
      try {
        const res = await joinListByToken(shareToken);
        setListId(res.list_id);
        setMessage(res.already ? 'Ya eres parte de esta lista.' : '¡Te uniste a la lista!');
        setState('success');
        // Auto-redirect to /me after 2s
        setTimeout(() => navigate('/me'), 1800);
      } catch (e) {
        setMessage(e?.response?.data?.detail || 'No pudimos unirte a esta lista.');
        setState('error');
      }
    })();
  }, [shareToken, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white grid place-items-center px-4">
      <Card className="max-w-md w-full rounded-2xl border-0 shadow-lg">
        <CardContent className="p-8 text-center">
          {state === 'loading' && (
            <>
              <Loader2 className="w-12 h-12 mx-auto mb-4 text-[#00CC66] animate-spin" />
              <h2 className="text-xl font-bold text-[#064E3B] mb-2">Uniéndote a la lista...</h2>
            </>
          )}
          {state === 'unauth' && (
            <>
              <Users className="w-12 h-12 mx-auto mb-4 text-[#00CC66]" />
              <h2 className="text-xl font-bold text-[#064E3B] mb-2">Inicia sesión para unirte</h2>
              <p className="text-gray-500 text-sm mb-5">Necesitas una cuenta PlanCity para acceder a esta lista compartida.</p>
              <div className="flex gap-2 justify-center">
                <Button onClick={() => navigate(`/login?next=/lists/join/${shareToken}`)} className="rounded-full bg-[#00CC66] hover:bg-[#00B359]">
                  Iniciar sesión
                </Button>
                <Button variant="outline" onClick={() => navigate(`/register?next=/lists/join/${shareToken}`)} className="rounded-full">
                  Crear cuenta
                </Button>
              </div>
            </>
          )}
          {state === 'success' && (
            <>
              <CheckCircle className="w-12 h-12 mx-auto mb-4 text-[#00CC66]" />
              <h2 className="text-xl font-bold text-[#064E3B] mb-2">{message}</h2>
              <p className="text-gray-500 text-sm mb-5">Te redirigiremos a tu panel...</p>
              <Button onClick={() => navigate('/me')} className="rounded-full bg-[#00CC66] hover:bg-[#00B359]">
                Ir a mi panel
              </Button>
            </>
          )}
          {state === 'error' && (
            <>
              <AlertCircle className="w-12 h-12 mx-auto mb-4 text-red-500" />
              <h2 className="text-xl font-bold text-[#064E3B] mb-2">{message}</h2>
              <Button onClick={() => navigate('/')} variant="outline" className="rounded-full mt-2">
                Volver al inicio
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
